import env from "../../config/env"

export const getBreadcrumbsHomeIcon = (icon: string, realm: string): string => {
    return `${env.REACT_APP_BLOB_STORAGE_PATH.replace(/\/$/, "")}/icons/shared/brand/${realm}/${icon}`
}
